import script from "./OrderMarket.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderMarket.vue?vue&type=script&setup=true&lang=ts"

import "./OrderMarket.vue?vue&type=style&index=0&id=3c260ee7&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c260ee7"]])

export default __exports__